<style src="./Cp1SuggestDistributor.scss" lang="scss" scoped></style>
<template>
  <input-suggest
    :label="label"
    :placeholder="placeholder"
    :rules="rules"
    @blur="blur"
    v-model="inputValue"
    class="suggest-distributor"
    min="1">

    <div class="notfound" slot="notfound">
      <span class="notfound-message">
        Essa empresa não existe em nosso cadastro.
      </span>
      <span
        v-if="isSaving"
        class="saving-message">
        Salvando...
      </span>
      <button
        v-if="!isSaving"
        @click="insertNew"
        class="btn btn-primary button">
        Clique para cadastra-la
      </button>
    </div>

    <input-suggest-item
      v-for="(item, idx) in suggestionList"
      :key="idx"
      :idx="idx"
      :item="item"
      class="client-item">

      <div class="client-row-top">
        <span class="short-name">{{ item.name }}</span>
      </div>
    </input-suggest-item>
  </input-suggest>
</template>
<script>
import InputSuggest from '../../cp1-input-suggest/InputSuggest'
import { InputSuggestMixin, InputSuggestItem } from '@/components/primitives/input-suggest'
import { SearchDistributorByName, SaveNewDistributor } from '@/brain/record/distributor'

export default {
  name: 'Cp1SuggestDistributor',
  mixins: [InputSuggestMixin],
  components: {
    InputSuggest,
    InputSuggestItem
  },
  data () {
    return {
      captionRaw: 'name',
      isSaving: false
    }
  },
  methods: {
    blur () {
      if (!this.isNotFound) {
        this.isNotFound = false
        this.$emit('blur')
      }
    },
    doSearch (pSearchTerm) {
      return SearchDistributorByName({ distributorName: pSearchTerm })
    },
    async insertNew () {
      this.isSaving = true
      const saveDistributor = await SaveNewDistributor({
        distributorName: this.inputValue.toUpperCase()
      })
      const itemInfo = {
        _id: saveDistributor.result._id,
        name: this.inputValue.toUpperCase()
      }
      this.selectingItemFromSuggestList(itemInfo)
      this.isSaving = false
      this.isNotFound = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/suggest/cp1-suggest-distributor/Cp1SuggestDistributor.vue